// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"4c462026","87":"02b763c0","356":"50090f40","376":"bc37b0a5","472":"d9f820bb","526":"85841fed","706":"dca20397","803":"9adc554e","848":"156c9078","928":"b145e539","950":"c07ba041","998":"4345fc5f"}[chunkId] + ".chunk.js";
};